const config = {
  baseDomain: process.env.REACT_APP_BASE_DOMAIN || 'template.net',
  datalayerEndpoint:
    process.env.REACT_APP_DATALAYER_ENDPOINT ||
    'https://msapi.template.net/conf/datalayer/getDatalayer',
}

export default config
